<div>
    <button (click)="buttonClick($event,config)" *ngFor="let config of configValue" class="rad-btn radio-btn-cls rectangle-5 btn-border width"
       [id]="'radio_'+ config['Name']" [ngClass]="{'btnUnselectedCls':(!config.isActive),'btnSelectedCls':(config.isActive)}" type="button" [name]="'radio_'+ config['Name']">{{config.Name}}</button>
</div>

<!-- <button class="radio-btn-cls btnUnselectedCls rectangle-5" type="button" ng-reflect-klass="radio-btn-cls" ng-reflect-ng-class="btnselectedCls" name="no" style="width: 50%;">No</button> -->